"use client";
import { FormGroup, Checkbox } from '@develos/next-components';
import { useTranslations } from '@develos/next-library';
import React, { useEffect } from 'react';
import { VehicleWarningFilterType } from '@/types';
import { useSelector } from 'react-redux';
import { storeSelectors } from '@/store';
import { VehicleParametersExceedeFilterMode } from '@/store/portalSettings';

type Props = {
    value: VehicleWarningFilterType,
    handleChange: (value: VehicleWarningFilterType) => void
}

const VehiclesWarningsFilter = ({ handleChange, value}: Props) => {
    const { translate } = useTranslations();
    const parametersExceededFilterMode = useSelector(storeSelectors.selectParametersExceededFilterMode);
    const isParametersExceededFilterModeOn = parametersExceededFilterMode == VehicleParametersExceedeFilterMode.OnlyWithExceededParameter;

    useEffect(() => {
        if(parametersExceededFilterMode === VehicleParametersExceedeFilterMode.OnlyWithExceededParameter){
            handleChange({...value, isOverweight: true, isOverheight: true, isSensorAvoided: true})
        }
        else{
            handleChange({...value, isOverweight: false, isOverheight: false, isSensorAvoided: false})
        }
    }, [parametersExceededFilterMode]);
    
    return (
        <FormGroup label={translate('Dostępne punkty preselekcyjne')}>
            <>
                <Checkbox
                    checked={value.isOverweight}
                    label={translate('Przekroczona waga')}
                    name="isOverweight"
                    onChange={() => handleChange({...value, isOverweight: !value.isOverweight})}
                    disabled={isParametersExceededFilterModeOn}
                />
                <Checkbox
                    checked={value.isOverheight}
                    label={translate('Przekroczona wysokość')}
                    name="isOverheight"
                    onChange={() => handleChange({...value, isOverheight: !value.isOverheight})}
                    disabled={isParametersExceededFilterModeOn}
                />
                <Checkbox
                    checked={value.isSensorAvoided}
                    label={translate('Ominięty czujnik nacisku')}
                    name="isSensorAvoided"
                    onChange={() => handleChange({...value, isSensorAvoided: !value.isSensorAvoided})}
                    disabled={isParametersExceededFilterModeOn}
                />
            </>
        </FormGroup>
    );
};

export default VehiclesWarningsFilter;